import DownloadApplicationSection from "../Components/downloadApplicationSection";
import RequestDemoSection from "../Components/requestDemoSection";

const Faq = () => {
    const faqs = [
        {
            title: "Who can benefit from using Mobithera?",
            desc: "Mobithera is ideal for physical therapists, rehabilitation clinics, sports medicine professionals, orthopedic centers, elderly care facilities, occupational therapists, and individuals recovering from injury or surgery. The platform streamlines progress monitoring and optimizes treatment plans."
        },
        {
            title: "Do I need any additional hardware to use the platform?",
            desc: "No additional hardware is required. Mobithera operates with any smartphone or tablet equipped with a camera, ensuring frictionless motion tracking and analysis."
        },
        {
            title: "Is the platform secure and compliant with data protection laws?",
            desc: "Yes. Mobithera implements end-to-end encryption and robust access controls. All personal health data is stored and processed in accordance with KVKK and GDPR regulations."
        },
        {
            title: "Is there multilingual support available for international users?",
            desc: "Yes. Mobithera offers multilingual interfaces and content localization to ensure an accessible experience for users worldwide."
        },
        {
            title: "What types of rehabilitation programs does Mobithera support?",
            desc: "Mobithera supports a comprehensive range of rehabilitation programs, including musculoskeletal rehabilitation, post-operative recovery, sports injury rehabilitation, neurologic and orthopaedic rehab, geriatric care and preventive exercise plans enriched with various training models."
        },
        {
            title: "How does the AI motion tracking system deliver feedback?",
            desc: "The AI analyzes live video input to evaluate posture, movement accuracy, and exercise compliance in real time. Instant feedback helps users correct form and maintain optimal technique."
        },
        {
            title: "Can I request a clinical demo before subscribing?",
            desc: "Absolutely. You can schedule a customized demo session through our website to experience the platform’s capabilities firsthand."
        },
        {
            title: "Can Mobithera be customized to match specific clinic workflows?",
            desc: "Yes. The platform offers configurable settings, treatment templates, and reporting tools to align with the unique protocols and workflows of your clinic or practice."
        },
        {
            title: "Does Mobithera provide progress analytics and outcome reports?",
            desc: "Yes. Mobithera generates detailed analytics dashboards and exportable reports that track patient adherence, progress metrics, and therapy outcomes over time."
        },
        {
            title: "How often is the platform updated with new features or clinical protocols?",
            desc: "Mobithera is continuously updated with enhancements, evidence-based protocols, and new capabilities. Users receive regular updates without disruption to their workflow."
        }
    ]

    return (
        <>
            <div style={{
                width: "100%",
                minHeight: "50vh",
                backgroundImage: "url('/FaqBg.jpg')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }} className="flex justify-content-start align-items-center px-4 md:px-8" >
                <p className="m-0" style={{ color: "#29345E", lineHeight: "1.2", fontSize: "3.25rem", fontWeight: 700 }} >
                    Frequently Asked Questions
                </p>
            </div>
            <div className="flex flex-wrap justify-content-center md:justify-content-start align-items-start py-8 px-4 md:px-8">
                <div className="flex flex-column justify-content-center align-items-start gap-4" >
                    {faqs.map((faq, index) => (
                        <div className="flex flex-column p-5 w-full" style={{ backgroundColor: "#F5F5F5", borderRadius: "16px" }}>
                            <div className="flex justify-content-between align-items-start mb-3">
                                <div className="flex gap-3" style={{ fontSize: "1.375rem", fontWeight: 700 }}>
                                    <p className="m-0" style={{ color: "#29345E" }} >{index + 1}.</p>
                                    <p className="m-0" style={{ color: "#29345E" }} >{faq.title}</p>
                                </div>
                                <img src="/Add.png" width={30} />
                            </div>
                            <p className="m-0 text-xl" style={{ color: "#727A99", textWrap: "wrap" }} >{faq.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
            {/*  Demo Access */}
            <RequestDemoSection />

            {/*  Applications */}
            <DownloadApplicationSection />
        </>
    )
}

export default Faq;